<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    
    list(body){
      return this.$http
        .get(`${VUE_APP_API_HOST}/sources`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`}
          },
          {body}
        )
        .then(res => res, err => err)
    },
    listSources(body){
      return this.$http
        .get(`${VUE_APP_API_HOST}/sources${body.section ? '?section=true' : ''}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`}
          },
          {body}
        )
        .then(res => res, err => err)
    },

    search(service, language, keyword, category){      
      let url = `${VUE_APP_API_HOST}/sources/search?service=${service}&language=${language}&keyword=${keyword}`
      if(category) url+= `&category=${category}`

      return this.$http
        .get(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`}
          }
        )
        .then(res => res, err => err)
    },
    searchSources(service, language, keyword, category){      
      let url = `${VUE_APP_API_HOST}/sources/search?service=${service}&language=${language}&keyword=${keyword}`
      if(category) url+= `&category=${category}`

      return this.$http
        .get(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`}
          }
        )
        .then(res => res, err => err)
    },

    new(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/sources/`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },
    newSource(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/sources/`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },

    delete(id){
      return this.$http
        .delete(`${VUE_APP_API_HOST}/sources/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },
    deleteSource(id){
      return this.$http
        .delete(`${VUE_APP_API_HOST}/sources/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    put(source){
      return this.$http
        .put(`${VUE_APP_API_HOST}/sources/${source.id}`,
          source,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },
    putSource(source){
      return this.$http
        .put(`${VUE_APP_API_HOST}/sources/${source.id}`,
          source,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    },

    listSourcesLanguages(service){
      return this.$http
        .get(`${VUE_APP_API_HOST}/sources/languages?service=${service}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(res => res, err => err)
    }
  }
}
</script>